module.exports = __webpack_public_path__ + "img/vsa_full_white.logo.101c7fff.png";